module.exports = __webpack_public_path__ + "static/media/29FUNOV10.7dd3589d.jpg";